import styled from "styled-components";

const BulletList = styled.ul`
  list-style: inside;
`;

export default BulletList;
